import { call, put, takeLatest } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import { filterTrackedUsers, withRetry } from '../../utils/common-functions';

function* filterGlobal({ payload }) {
    yield put({ type: actions.TRAINERS_FETCH_LOADING, payload: { loading: true } });
    try {
        const trainers = yield call(withRetry(filterTrackedUsers), payload);
        yield put({ type: actions.GLOBAL_FETCHED, payload: trainers.data });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Os trainers não puderam ser carregados. Tente recarregar a página' } });
    }
    yield put({ type: actions.TRAINERS_FETCH_LOADING, payload: { loading: false } });
}

export default function* global() {
    yield takeLatest(actions.ASYNC_FILTER_GLOBAL, filterGlobal);
}



// WEBPACK FOOTER //
// ./src/components/global/global.saga.js